@if (!shown) {
    <print-button (notifyOpen)="notifyOpen($event)"></print-button>
} @else {
    <div id="printDialogue">
        <div print-header
             [printButtonDisabled]="printButtonDisabled"
             (notifyOpen)="notifyOpen($event)"></div>
        <!-- Start printContent: Zusammenfassung Bürgschaftsantrag -->
        <div class="printContent show">
            <!-- DOCUMENT TITLE -->
            <h1 class="printTitle">
                Ihr Bürgschaftsantrag
            </h1>
            <!-- CONTENT START -->
            <div class="gridContainer printGrid">
                <h2>
                    1. Antragsteller
                </h2>
                <div class="gridContainer dataGrid">
                    <div class="row">
                        <div class="cell grid-100">
                            <bgsch-create-abschl-1 [model]="model" [printMode]="true"></bgsch-create-abschl-1>
                        </div>
                    </div>
                </div>
                <h2>
                    2. Auftraggeber
                </h2>
                <div class="gridContainer dataGrid">
                    <div class="row">
                        <div class="cell grid-100">
                            <bgsch-create-abschl-2 [model]="model" [printMode]="true"></bgsch-create-abschl-2>
                        </div>
                    </div>
                </div>
                <h2>
                    3. Bürgschaft
                </h2>
                <div class="gridContainer dataGrid">
                    <div class="row">
                        <div class="cell grid-100">
                            <bgsch-create-abschl-3 [model]="model" [printMode]="true"></bgsch-create-abschl-3>
                        </div>
                    </div>
                </div>
                <h2>
                    4. Erklärung
                </h2>
                <div class="gridContainer dataGrid">
                    <div class="row">
                        <div class="cell grid-100">
                            <bgsch-create-abschl-4 [model]="model" [printMode]="true"></bgsch-create-abschl-4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
